const GOOGLE_PLACES_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let hasWarnedMissingKey = false;

export const autocompletePlaces = async (input) => {
  const keyword = input?.trim();

  if (!keyword || keyword.length < 2) {
    return [];
  }

  if (!GOOGLE_PLACES_API_KEY) {
    if (!hasWarnedMissingKey) {
      console.warn("REACT_APP_GOOGLE_MAPS_API_KEY is missing in .env");
      hasWarnedMissingKey = true;
    }

    return [];
  }

  const response = await fetch("https://places.googleapis.com/v1/places:autocomplete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Goog-Api-Key": GOOGLE_PLACES_API_KEY,
      "X-Goog-FieldMask":
        "suggestions.placePrediction.placeId,suggestions.placePrediction.text,suggestions.placePrediction.structuredFormat",
    },
    body: JSON.stringify({
      input: keyword,
      languageCode: "th",
      regionCode: "TH",
      includeQueryPredictions: false,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || "Failed to fetch Google Places suggestions");
  }

  const payload = await response.json();

  return (payload?.suggestions || [])
    .map((item) => item?.placePrediction)
    .filter(Boolean)
    .map((place) => ({
      placeId: place.placeId,
      displayName: place.text?.text || "",
      primaryText:
        place.structuredFormat?.mainText?.text || place.text?.text || "",
      secondaryText: place.structuredFormat?.secondaryText?.text || "",
    }));
};
